"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal_UICreateAlerts = void 0;
const domElemHelper_1 = require("../../helpers/domElemHelper");
/** Modal for run Actions and Alerts */
function Modal_UICreateAlerts() {
    const html = require('./UIAlerts.html').default;
    const $elem = (0, domElemHelper_1.UICreateElemFromString)(html, 'div');
    const $actions_text = $elem.querySelector('#actions-text');
    const $error_text = $elem.querySelector('#errors-text');
    $elem.addEventListener('updatemodal', function (e) {
        const details = e.detail;
        //console.log(details);
        $actions_text.value = details.actions || '';
        $error_text.value = details.errors || '';
    });
    return $elem;
}
exports.Modal_UICreateAlerts = Modal_UICreateAlerts;
